// FAQ copy. Every answer is checked against what the app does today; keep it that way.
export const FAQ_GROUPS = [
    {
        k: '個',
        name: 'Importing your own car',
        qs: [
            {
                q: 'Can I use Right Hand DMS if I’m not a dealer?',
                a: 'Yes. Import my own is for one person bringing in a JDM car or truck for themselves, in their own name or through an LLC. You pay once to sign up, which covers your first car and 90 days of searching. After that, each car pass covers one car you win and another 90 days of searching. The Pricing page has today’s figures.'
            },
            {
                q: 'What if I don’t win a car?',
                a: 'Searching is included for 90 days from sign-up and from each car pass. When that runs out, your hunts pause until you add a pass. If you haven’t won a car, you can ask for your sign-up back. We suggest giving it a few months first (the Pricing page has the days). We refund it minus what you used, at retail prices the app shows you before you ask.'
            },
            {
                q: 'Do I need a dealer license to import my own?',
                a: 'Not for Right Hand DMS. Whether you need one to import, register or later sell a car isn’t ours to say. Ask your state DMV or title office and your customs broker, and read CBP’s “Importing a Motor Vehicle” page and the EPA and NHTSA vehicle import pages.'
            }
        ]
    },
    {
        k: '代理',
        name: 'Auction logins and agents',
        qs: [
            {
                q: 'Which export agents do you work with?',
                a: 'JapanCarDirect, JDM Auc and Pacific Coast JDM. If you buy through someone else, tell us who on a call.'
            },
            {
                q: 'Do I need my own agent account?',
                a: 'Yes. Right Hand DMS searches through the accounts you already have. It isn’t an agent, and it doesn’t buy cars.'
            },
            {
                q: 'Does it place bids for me?',
                a: 'No. It finds lots, reads them and prices them. Every bid is your call.'
            }
        ]
    },
    {
        k: '安全',
        name: 'Data and security',
        qs: [
            {
                q: 'How are my agent logins stored?',
                a: 'They’re encrypted at rest, and we use them only to run your own searches.'
            },
            {
                q: 'Can other shops see my data?',
                a: 'No. Each account’s data is isolated from every other account.'
            },
            {
                q: 'Can I export my data?',
                a: 'You can download your documents any time. For cars and costs, ask us and we’ll export them for you.'
            }
        ]
    },
    {
        k: '郵便',
        name: 'Email connections',
        qs: [
            {
                q: 'Which mailboxes are supported?',
                a: 'Fastmail, or any email over IMAP, such as Gmail, iCloud, Yahoo, Zoho or your own host.'
            },
            {
                q: 'Will it email my customers without asking?',
                a: 'Only if you turn on auto-send. Until then, customer emails wait in your Outbox for you to approve.'
            },
            {
                q: 'What does it read in my mailbox?',
                a: 'Two things: agent replies to your sheet requests, and threads linked to your hunts, cars and customers.'
            }
        ]
    },
    {
        k: '原価',
        name: 'Documents and costs',
        qs: [
            {
                q: 'What documents can I upload?',
                a: 'Auction and agent invoices, transfers, bills of lading, broker invoices and the CBP 7501, plus port, trucking and title receipts.'
            },
            {
                q: 'Does it estimate costs I haven’t paid yet?',
                a: 'No. Costs come only from your paperwork, and a document you haven’t added shows as missing.'
            },
            {
                q: 'How is the exchange rate chosen?',
                a: 'It comes from the document itself. Failing that, it uses your Wise transfer for that car, then the latest rate already on the car. If there’s none, you enter it.'
            }
        ]
    },
    {
        k: '対応',
        name: 'What’s supported',
        qs: [
            {
                q: 'Which vehicles?',
                a: 'Any Japanese-market vehicle on those exporters’ auctions that’s old enough to import. That includes sports cars, sedans, wagons, vans, 4x4s and kei trucks.'
            },
            {
                q: 'Do you support Canada or other countries?',
                a: 'US imports only for now.'
            },
            {
                q: 'Is there a mobile app?',
                a: 'There’s no separate app. The web app works on your phone.'
            }
        ]
    }
];
